import { render, staticRenderFns } from "./exportbatch.vue?vue&type=template&id=0f86b4b6"
import script from "./exportbatch.vue?vue&type=script&lang=js"
export * from "./exportbatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports